import { useQuery } from "@tanstack/react-query";
import { supabase } from "@/integrations/supabase/client";
import { useAuth } from "@/contexts/AuthContext";

/**
 * Resolves the current user's UNA the same way UNAGovernance/UNAMembers do:
 * treasury secretary first, then una_members. Returns null when not linked.
 */
export const useMemberUna = () => {
  const { user } = useAuth();

  const query = useQuery({
    queryKey: ["member-una", user?.id],
    queryFn: async () => {
      if (!user?.id) return null;

      const { data: unaAsTS } = await supabase
        .from("unas")
        .select("id, name")
        .eq("treasury_secretary_id", user.id)
        .maybeSingle();

      if (unaAsTS) {
        return { una_id: unaAsTS.id as string, una_name: unaAsTS.name as string };
      }

      const { data } = await supabase
        .from("una_members")
        .select("una_id, una:una_id(name)")
        .eq("user_id", user.id)
        .eq("status", "active")
        .maybeSingle();

      if (!data?.una_id) return null;
      return {
        una_id: data.una_id as string,
        una_name: (data.una as any)?.name ?? "",
      };
    },
    enabled: !!user?.id,
    staleTime: 60_000,
  });

  return {
    unaId: query.data?.una_id ?? null,
    unaName: query.data?.una_name ?? "",
    isLoading: query.isLoading,
  };
};
